module.exports = __webpack_public_path__ + "img/logo-text.4638cd0f.png";